<template>
  <div class="step-control mr-5 flex items-center">
    <el-tooltip :content="$t('撤销 (Ctrl+Z)')" placement="bottom" :open-delay="500">
      <div 
        class="step-btn" 
        :class="{ 'disabled': !lastStep }" 
        @click="toAction('prev')"
      >
        <prev-svg class="icon" />
      </div>
    </el-tooltip>
    <el-tooltip :content="$t('重做 (Ctrl+Shift+Z)')" placement="bottom" :open-delay="500">
      <div 
        class="step-btn" 
        :class="{ 'disabled': !lastSaveStep }" 
        @click="toAction('next')"
      >
        <next-svg class="icon" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import { on } from '@/utils/dom'
import prevSvg from '~/assets/svg/icon/iconPrev.svg'
import nextSvg from '~/assets/svg/icon/iconNext.svg'

export default {
  name: 'StepControl',
  components: {
    prevSvg,
    nextSvg
  },
  props: {
    siteModel: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    lastStep() {
      const steps = this.$store.state.editor.steps
      return steps[steps.length - 1]
    },
    lastSaveStep() {
      const steps = this.$store.state.editor.stepsStorage
      return steps[steps.length - 1]
    }
  },
  mounted() {
    on(document, 'keydown', this.listenKeyDown)
  },
  methods: {
    listenKeyDown(e) {
      const { metaKey, ctrlKey, shiftKey, key } = e
      const isCtrl = ctrlKey || metaKey
      const isZ = key.toLowerCase() === 'z'
      
      // Ctrl + Z
      if (isCtrl && !shiftKey && isZ) {
        e.preventDefault()
        this.toAction('prev')
      } 
      // Ctrl + Shift + Z (Mac上通常也是Redo)
      else if (isCtrl && shiftKey && isZ) {
        e.preventDefault()
        this.toAction('next')
      }
    },
    toAction(type) {
      const isPrev = type === 'prev'
      const step = isPrev ? this.lastStep : this.lastSaveStep
      
      if (!step) return

      this.siteModel.resetAction(this, step, type)
      this.$nextTick(() => {
        const mutation = isPrev ? 'editor/REMOVE_LAST_STEP' : 'editor/REMOVE_LAST_STORAGE_STEP'
        this.$store.commit(mutation)
        this.SiteMenu.$bus.$emit('updateAlpha')
      })
    }
  }
}
</script>

<style scoped lang="less">
.step-control {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 4px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  gap: 4px;
  display: flex;
  align-items: center;

  .step-btn {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    color: var(--text-light-color);
    position: relative;

    &:hover:not(.disabled) {
      background-color: rgba(255, 255, 255, 0.1);
      color: #fff;
      transform: translateY(-1px);
    }

    &:active:not(.disabled) {
      background-color: rgba(255, 255, 255, 0.05);
      transform: translateY(0) scale(0.95);
    }

    &.disabled {
      color: rgba(255, 255, 255, 0.15);
      cursor: not-allowed;
      background-color: transparent;
      
      .icon {
        opacity: 0.4;
      }
    }

    .icon {
      width: 16px;
      height: 16px;
      fill: currentColor;
      transition: opacity 0.2s ease;
    }
  }
}
</style>
